import React from "react";
import { initials } from "@/lib/api";

export default function MemberAvatar({ user, size = 48, className = "" }) {
  const name = user?.display_name || user?.username || user?.first_name || "Member";
  const photo = user?.profile_photo;
  const dim = { width: size, height: size, minWidth: size };
  if (photo) {
    return (
      <img
        src={photo}
        alt={name}
        style={dim}
        className={`rounded-full object-cover bg-[#F2EFE8] border border-[#E3DED4] ${className}`}
      />
    );
  }
  return (
    <div
      style={{ ...dim, fontSize: Math.max(12, size * 0.34) }}
      className={`rounded-full flex items-center justify-center font-semibold bg-[#D7EEF0] text-[#1F6F78] border border-[#BFE0E3] ${className}`}
      aria-hidden="true"
    >
      {initials(name)}
    </div>
  );
}
